import {BaseStore, globalStore} from "../../../stem-core/state/Store";
import {field} from "../../../stem-core/state/StoreField.js";
import {StemDate} from "../../../stem-core/time/Date";

@globalStore
export class AnalyticsEvent extends BaseStore("AnalyticsEvent") {
    @field(String) type: string;
    @field(String) origin: string;
    @field(Date) createdAt: StemDate;
    @field(Number) timestamp: number;
    @field(Number) localSessionTime: number;
    @field(String) ip: string;

    /// TODO @branch some more fields, when done

    @field(Object) payload: Record<string, any>;
}
